import './VolunteersPage.css';
import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import { Link } from 'react-router-dom';

const volunteersPrinciples = [
  'Равенство перед законом общественных объединений пожарной охраны независимо от их организационно-правовых форм.',
  'Добровольность, равноправие и законность деятельности добровольной пожарной охраны.',
  'Свобода в определении внутренней структуры добровольной пожарной охраны, целей, форм и методов деятельности добровольной пожарной охраны.',
  'Гласность и общедоступность информации о деятельности добровольной пожарной охраны.',
  'Готовность подразделений добровольной пожарной охраны и добровольных пожарных к участию в профилактике и (или) тушении пожаров, проведении аварийно-спасательных работ и оказанию первой помощи пострадавшим.',
  'Приоритетность спасения людей и оказания первой помощи пострадавшим при тушении пожаров и проведении аварийно-спасательных работ.',
  'Обоснованность риска и обеспечение безопасности добровольных пожарных при тушении пожаров и проведении аварийно-спасательных работ.',
];

function VolunteersPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="volunteers">
          <div className="volunteers__breadcrumbs">
            <Link to="/" className="volunteers__breadcrumbs-link">
              Главная
            </Link>
            <span className="volunteers__breadcrumbs-separator">/</span>
            <span className="volunteers__breadcrumbs-current">
              Как стать добровольцем
            </span>
          </div>

          <div className="volunteers__hero">
            <h2 className="volunteers__title">Как стать добровольцем</h2>
            <p className="volunteers__lead">
              Принципы, в соответствии с которыми реализуются мероприятия по
              созданию общественных объединений пожарной охраны
            </p>
          </div>

          <ol className="volunteers__list">
            {volunteersPrinciples.map((principle) => (
              <li className="volunteers__list-item" key={principle}>
                {principle}
              </li>
            ))}
          </ol>

          <section className="volunteers__video">
            <div className="volunteers__video-content">
              <h3 className="volunteers__video-title">
                Материалы о деятельности добровольцев на Rutube
              </h3>
              <p className="volunteers__video-text">
                Откройте канал, чтобы посмотреть актуальные видеоматериалы
              </p>
            </div>
            <a
              href="https://rutube.ru/channel/23897170/?utm_source=embed&utm_medium=referral&utm_campaign=channel_left&utm_content=623aaf2f54ff9326d23939622999eb92&utm_term=vdpo.ru"
              className="volunteers__video-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Смотреть на Rutube
            </a>
          </section>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default VolunteersPage;
